import { Axios } from "axios";

import {
  ISystemNotificationrBody,
  systemNotificationService,
} from "services/systemNotification";

export const getAllNotifications = async (
  api: Axios,
  userId: number,
): Promise<ISystemNotificationrBody[]> => {
  const list = await systemNotificationService.getAllByUser(userId);

  if (list.status === 200) {
    // The API can return either a raw notification array or the standard
    // response wrapper: { data: [...] }.
    return Array.isArray(list.data) ? list.data : list.data?.data ?? [];
  } else {
    return [];
  }
};

export const readNotification = async (api: Axios, notificationId: number) => {
  return await systemNotificationService.setReaded(notificationId);
};

export const readAllNotifications = async (
  api: Axios,
  list: Array<ISystemNotificationrBody>,
) => {
  try {
    return await systemNotificationService.setReadedAll(list);
  } catch (error: any) {
    console.error("Erro ao marcar todas notificações como lidas:", error);
    return { status: error?.response?.status || 500, data: null };
  }
};
